import { Button, Icon, Menu, MenuButton, MenuItem, MenuList } from 'design-system';
import { usePageParams } from 'hooks/use-page-params';
import { BiChevronDown } from 'react-icons/bi';

interface IOriginFilterButton {
  // Derived from the currently-loaded rows — no distinct-origins lookup endpoint
  // exists yet (known gap in the handoff), so origins outside this page are missed.
  options: string[];
}

export const OriginFilterButton = ({ options }: IOriginFilterButton) => {
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();
  const active = params.origin as string | undefined;

  // Keep the applied origin visible in the list even when the filtered result
  // set no longer contains it.
  const items = active && !options.includes(active) ? [active, ...options] : options;

  const apply = (origin?: string) => {
    const next = { ...params };
    delete next.page;
    if (origin) next.origin = origin;
    else delete next.origin;
    setPageParams(next);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        size='sm'
        variant='outline'
        fontWeight='semibold'
        color='gray.600'
        rightIcon={<Icon as={BiChevronDown} />}>
        Origin: {active ?? 'All'}
      </MenuButton>
      <MenuList>
        <MenuItem fontWeight={!active ? 'bold' : 'normal'} onClick={() => apply(undefined)}>
          All
        </MenuItem>
        {items.map((origin) => (
          <MenuItem key={origin} fontWeight={origin === active ? 'bold' : 'normal'} onClick={() => apply(origin)}>
            {origin}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
